"use client";

import { cn } from "@/lib/utils";

interface GridBackgroundProps {
  className?: string;
}

export function GridBackground({ className }: GridBackgroundProps) {
  return (
    <div
      className={cn("fixed inset-0 overflow-hidden pointer-events-none", className)}
      aria-hidden="true"
    >
      {/* Radial gradient overlay */}
      <div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(ellipse at 50% 0%, rgba(189, 0, 255, 0.15) 0%, transparent 50%),
            radial-gradient(ellipse at 80% 50%, rgba(255, 16, 240, 0.08) 0%, transparent 40%),
            radial-gradient(ellipse at 20% 80%, rgba(0, 128, 255, 0.08) 0%, transparent 40%)
          `,
        }}
      />

      {/* Perspective grid */}
      <div
        className="absolute bottom-0 left-0 right-0 h-[60vh]"
        style={{
          perspective: "500px",
          perspectiveOrigin: "50% 0%",
        }}
      >
        <div
          className="absolute inset-0"
          style={{
            transform: "rotateX(60deg)",
            transformOrigin: "top center",
            backgroundImage: `
              linear-gradient(rgba(0, 255, 255, 0.06) 1px, transparent 1px),
              linear-gradient(90deg, rgba(0, 255, 255, 0.06) 1px, transparent 1px)
            `,
            backgroundSize: "60px 60px",
          }}
        />
      </div>

      {/* Horizon glow line */}
      <div
        className="absolute left-0 right-0 h-[1px]"
        style={{
          bottom: "40vh",
          background: `linear-gradient(
            90deg,
            transparent 0%,
            rgba(255, 16, 240, 0.4) 20%,
            rgba(0, 255, 255, 0.6) 50%,
            rgba(255, 16, 240, 0.4) 80%,
            transparent 100%
          )`,
          boxShadow: "0 0 20px rgba(0, 255, 255, 0.3), 0 0 60px rgba(255, 16, 240, 0.15)",
        }}
      />

      {/* Sun/moon circle */}
      <div
        className="absolute left-1/2 -translate-x-1/2"
        style={{
          bottom: "38vh",
          width: "200px",
          height: "200px",
          background: `linear-gradient(
            180deg,
            rgba(255, 16, 240, 0.3) 0%,
            rgba(255, 107, 0, 0.15) 40%,
            transparent 70%
          )`,
          borderRadius: "50%",
          filter: "blur(30px)",
        }}
      />
    </div>
  );
}
